import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mobileFirstCss } = mediaQueryStyles;
const { colors } = constants;

export const rootCss = mobileFirstCss({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: [
    "48px 16px 0px 16px",
    "48px 16px 0px 16px",
    "64px 64px 12px 64px",
    "64px 64px 12px 64px",
    "80px 112px 12px 112px",
  ],
});

export const rootViewAsStudentCss = {
  maxWidth: "996px",
  borderBottom: `1px ${colors.ui.neutral[300]} solid`,
  marginBottom: "68px",
};

export const instructionsViewAsStudentCss = {
  marginBottom: "48px",
};

export const informationViewAsStudentCss = {
  marginBottom: "48px",
};
